import {TEAM_SUPPORT_REGISTER} from "../../types";

const initialState = {};
const TeamSupportRegisterReducer = (state = initialState, action) => {
    switch (action.type) {
       
        case TEAM_SUPPORT_REGISTER:{
            state=action.payload;
            return state;
        }
        default: return state;
    }
}

export default TeamSupportRegisterReducer;